import type { ModelLead } from '@app/api/Leads/types';
import type { ModelSalesFunnelStageLeads } from '@app/api/SalesFunnels';

import {
  parseLeadSortableId,
  parseStageDroppableId,
} from './leadsFunnelDndIds';
import { findStageIdByLeadId } from './moveStageLead';

import type { DragOverEvent, Over, UniqueIdentifier } from '@dnd-kit/core';

export const findLead = (
  stages: ModelSalesFunnelStageLeads[],
  leadId: number
): ModelLead | null => {
  for (const stage of stages) {
    const lead = (stage.Leads ?? []).find((item) => item.Id === leadId);
    if (lead) return lead;
  }

  return null;
};

export const resolveOverStageId = (
  over: Over,
  stages: ModelSalesFunnelStageLeads[]
): number | null => {
  const stageId = parseStageDroppableId(over.id);
  if (stageId !== null) return stageId;

  const overLeadId = parseLeadSortableId(over.id);
  if (overLeadId === null) return null;

  return findStageIdByLeadId(stages, overLeadId);
};

export const resolveTargetIndex = (
  overId: UniqueIdentifier,
  targetStage: ModelSalesFunnelStageLeads,
  isBelowOverItem: boolean
): number => {
  const overLeadId = parseLeadSortableId(overId);
  const leads = targetStage.Leads ?? [];

  if (overLeadId === null) return leads.length;

  const overIndex = leads.findIndex((lead) => lead.Id === overLeadId);
  if (overIndex < 0) return leads.length;

  return overIndex + (isBelowOverItem ? 1 : 0);
};

export const getIsBelowOverItem = (event: DragOverEvent): boolean => {
  const activeRect = event.active.rect.current.translated;
  const overRect = event.over?.rect;

  if (!activeRect || !overRect) return false;

  return activeRect.top > overRect.top + overRect.height / 2;
};
